<template>
  <!-- Chart container starts here -->
  <div>
    <div v-if="chartData && trend.length > 1">
      <LineChart :data="chartData" :options="chartOptions" />
    </div>
    <div v-else>
      <p class="mb-2">
        Regular blood testing means you can witness the changes to
        your body that you cannot physically see.
      </p>

      <p class="mb-2">
        Whilst you may feel lighter, brighter and be sleeping better
        testing every 3 months will show you the improvements you're
        making on the inside.
      </p>

      <p class="mb-2">
        You can also view your trends over time, the more tests you
        have the better the picture will be of your over all health
        and improvements.
      </p>
    </div>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement } from 'chart.js';
import { computed } from 'vue';
import { useResultsStore } from "@/store/results";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement);

export default {
  name: 'LiverFunction',
  components: {
    LineChart: Line,
  },
  props: {
    marker: {
      type: Object,
      required: true,
    },
    selectedBloodTest: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const resultsStore = useResultsStore();
    const trend = computed(() => {
      return props.marker?.resultRangeStage ? getMarkerResultsOverTime(props.marker) : [];
    });
    function getMarkerResultsOverTime(targetMarker) {
      return [...resultsStore.bloodResults]
        .sort((a, b) => {
          const date1 = Date.parse(a.date);
          const date2 = Date.parse(b.date);
          if (date1 > date2) {
            return 1;
          } else if (date1 < date2) {
            return -1;
          } else {
            return 0;
          }
        })
        .flatMap(() =>
          props.selectedBloodTest.result.panels.flatMap((panel) =>
            panel.markers
              .filter((marker) => marker.name === targetMarker.name)
              .map((marker) => ({
                date: props.selectedBloodTest.result.date,
                result: marker.result,
                stageName: marker.resultRangeStage.name,
              }))
          )
        );
    }
    const chartData = computed(() => {
      const data = {
        labels: trend.value.map(t => new Date(t.date).toLocaleDateString('en-GB', { month: 'short', day: 'numeric' })),
        datasets: [
          {
            label: 'Liver',
            data: trend.value.map(t => t.result),
            fill: false,
            borderColor: 'rgba(34, 197, 94, 1)',
            tension: 1.1,
            pointRadius: 8,
            pointHoverRadius: 10,
            pointBackgroundColor: 'rgba(34, 197, 94, 1)',
          },
        ],
      };
      return data;
    });
    const chartOptions = {
      scales: {
        x: {
          ticks: {
            font: {
              family: 'Poppins',
            },
          },
          title: {
            display: true,
            text: '',
            font: {
              family: 'Poppins',
            },
          },
        },
        y: {
          ticks: {
            font: {
              family: 'Poppins',
            },
          },
          title: {
            display: true,
            text: '',
            font: {
              family: 'Poppins',
            },
          },
        },
      },
      plugins: {
        legend: {
          labels: {
            font: {
              family: 'Poppins',
            },
          },
        },
        tooltip: {
          bodyFont: {
            family: 'Poppins',
          },
          titleFont: {
            family: 'Poppins',
          },
        },
      },
    };
    return {
      chartData,
      chartOptions,
      trend
    };
  },
};
</script>
